var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("network-button-window", {
    attrs: {
      "window-name": _vm.$tc("Calculation", 2),
      "parent-toggle-window": _vm.windowOpen,
      disabled: _vm.buttonsDisabled
    },
    on: { toggleWindow: _vm.restartOnWindowOpen },
    scopedSlots: _vm._u([
      {
        key: "buttonIcon",
        fn: function() {
          return [_c("CalculationsSVG", { staticClass: "calculations-icon" })]
        },
        proxy: true
      },
      {
        key: "windowContent",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "processes-inner-container" },
              [
                _c("process-item", {
                  attrs: {
                    name: "All",
                    selected: _vm.all.checked,
                    loading: _vm.runLoading,
                    selection: _vm.runSelection,
                    run: _vm.runLoading,
                    "all-checkbox-is-disabled": _vm.allCheckboxIsDisabled
                  },
                  on: { toggle: _vm.toggleAllProcesses }
                }),
                _vm._v(" "),
                _vm._l(_vm.processes, function(item) {
                  return _c("process-item", {
                    key: item.name,
                    attrs: {
                      name: item.name,
                      selected: item.state.checked,
                      loading: item.state.loading,
                      complete: item.state.result,
                      selection: _vm.runSelection,
                      run: _vm.runLoading,
                      permissionName: item.permission
                    },
                    on: {
                      toggle: function($event) {
                        item.state.checked = $event
                      }
                    }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.runSelection
              ? _c("processes-button", {
                  attrs: { buttonName: "Run", disabled: !_vm.runEnabled },
                  on: { onClick: _vm.runProcesses }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.runSelection && !_vm.runLoading && _vm.runComplete
              ? _c("processes-button", {
                  attrs: { buttonName: "Restart" },
                  on: { onClick: _vm.restart }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-567d3523", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567d3523","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Network/Calculations/Calculations.vue
// module id = null
// module chunks = 